export const menu = [{
        name: '交易记录',
        id: '1',
        icon: 'ficon-phone-o',
        child: [{
                name: '我的订单',
                id: '11',
                is: true
            },
            {
                name: '我的会员',
                id: '14',
                is: true
            },
            {
                name: '我的积分',
                id: '12',
                is: true
            },
            {
                name: '我的红包',
                id: '13',
                is: true
            },
            {
                name: '积分兑换优惠券',
                id: '16',
                is: true
            },
            {
                name: '积分兑换商品',
                id: '17',
                is: true
            },
            {
                name: '我的优惠券',
                id: '15',
                is: true
            },

            // {
            //     name: '订单详情',
            //     id: '16',
            //     is: false
            // },
            // {
            //     name: '申请售后',
            //     id: '17',
            //     is: false
            // },
            // {
            //     name: '评价',
            //     id: '18',
            //     is: false
            // },
        ]
    },
    {
        name: '收藏夹',
        id: '2',
        icon: 'ficon-phone-o',
        child: [{
                name: '商品收藏',
                id: '21',
                is: true
            },
            {
                name: '采购清单',
                id: '22',
                is: true
            },
            {
                name: '历史采购清单',
                id: '23',
                is: true
            },
        ]
    },
    {
        name: '个人设置',
        id: '3',
        icon: 'ficon-phone-o',
        child: [{
                name: '个人信息',
                id: '31',
                is: true
            },
            {
                name: '修改密码',
                id: '32',
                is: true
            },
            {
                name: '收货地址',
                id: '33',
                is: true
            },
        ]
    },
    {
        name: '站内消息',
        id: '4',
        icon: 'ficon-phone-o',
        child: [{
                name: '发送消息',
                id: '41',
                is: true
            },
            {
                name: '收件箱',
                id: '42',
                is: true
            },
            {
                name: '草稿箱',
                id: '43',
                is: true
            },
            {
                name: '发件箱',
                id: '44',
                is: true
            },
            {
                name: '给管理员发消息',
                id: '45',
                is: true
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/views/index/mine/menu.js